export interface UserIdentity {
  uuid?: string;
  accessToken?: string;
  refreshToken?: string;
  impersonator?: string;
  idToken?: string;
  expiresIn?: number;
  disqus?: {
    enabled: boolean;
    publicKey: string;
    ssoKey?: string;
  };
}

/** @hidden */
export interface UpdatePasswordSuccessResponse {
  userName: string;
  passwordReset: boolean;
  type: string;
  lastLoginDate?: number;
  locked?: boolean;
}

/** @hidden */
export function isUpdatePasswordSuccessResponse(
  object: any
): object is UpdatePasswordSuccessResponse {
  return (<UpdatePasswordSuccessResponse>object).userName !== undefined;
}

/** @hidden */
export function isUserIdentity(object: any): object is UserIdentity {
  return (<UserIdentity>object).uuid !== undefined;
}
